var map = {
	"./app-code.png": "0ad9",
	"./appQRcodeB.jpeg": "c234",
	"./appQRcodeC.jpg": "e8d4",
	"./appQRcodeC.png": "210b",
	"./icon4.png": "a01a",
	"./nfstQRcode.png": "4ae6",
	"./recharge.png": "8c94",
	"./wechatQRcode.png": "50a8",
	"./yxqn-QRCode-v2.jpg": "bdcb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b676";